import { TableCard } from '../../../../components'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { NotificacoesEnviadasListHeader } from './components/header/NotificacoesEnviadasListHeader'
import { NotificacoesEnviadasTable } from './table/NotificacoesEnviadasTable'

const NotificacoesEnviadasList = () => {
  return (
    <TableCard>
      <NotificacoesEnviadasListHeader />
      <NotificacoesEnviadasTable />
    </TableCard>
  )
}

export const NotificacoesEnviadasListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <NotificacoesEnviadasList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
